<template>
    <div>
        <template v-for="(alert, index) in alerts">
            <alerts-item
                v-bind="{
                    index,
                    alert,
                }"
                :key="index"
            />
        </template>
    </div>
</template>

<script>
import { mapState } from "vuex";
import AlertsItem from "./alerts/alerts-item.vue";

export default {
    components: {
        AlertsItem,
    },
    computed: {
        ...mapState("interview/server", ["alerts"]),
    },
};
</script>